import React from "react";
import {ColumnLayout, Input, Select} from "@amzn/awsui-components-react";
import {AGGREGATE_TYPES, OPERATION_TYPES} from "../CalcDetails";

export class OperationCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {...this.props.data};
  }

  handleChange = (change, e) => {
    const newState = {};
    newState[change] = e.detail.selectedId;;
    this.setState(newState, () => {
      this.props.onChange({...this.state});
    });
  }


  handleValueChange = (change, e) => {
    const newState = {};
    newState[change] = e.detail.value;
    this.setState(newState, () => {
      this.props.onChange({...this.state});
    });
  }

  render() {
    const selection0 = this.props.results.filter(x => x[1] === this.props.data.item0);
    const selection1 = this.props.results.filter(x => x[1] === this.props.data.item1);
    return <ColumnLayout columns={3}>
      <div data-awsui-column-layout-root="true">
        <div>
          Column 1:
          <Select options={this.props.results.map((x) => {
            return {label: x[0], id: x[1]};
          })}
                  selectedOption={{
                    label: selection0.length > 0? selection0[0][0]: "",
                    id: selection0.length > 0? selection0[0][0]: "",
                  }}
                  onChange={(e) => this.handleChange('item0', e)}
                  selectedLabel="Selected"
                  filteringType={"auto"}
                  disabled={this.props.disabled}/>
        </div>
        <div>
          Column 2:
          <Select options={this.props.results.map((x) => {
            return {label: x[0], id: x[1]};
          })}
                  selectedOption={{
                    label: selection1.length > 0? selection1[0][0]: "",
                    id: selection1.length > 0? selection1[0][0]: "",
                  }}
                  onChange={(e) => this.handleChange('item1', e)}
                  selectedLabel="Selected"
                  filteringType={"auto"}
                  disabled={this.props.disabled}/>
        </div>
        <div>
          Operation:
          <Select options={OPERATION_TYPES.map((x) => {
            return {label: x, id: x};
          })}
                  selectedOption={{
                    label: this.props.data.operation,
                    id: this.props.data.operation
                  }}
                  onChange={(e) => this.handleChange('operation', e)}
                  selectedLabel="Selected"
                  disabled={this.props.disabled}/>
        </div>
        <div>
          Output table:
          <Select options={this.props.sources.map((x) => {
            return {label: x, id: x};
          })}
                  selectedOption={{
                    label: this.props.data.output_table,
                    id: this.props.data.output_table
                  }}
                  onChange={(e) => this.handleChange('output_table', e)}
                  selectedLabel="Selected"
                  disabled={this.props.disabled}/>
        </div>
        <div>
          Output Column:
          <Input value={this.props.data.output_column}
                 onChange={(e) => this.handleValueChange('output_column', e)}
                 disabled={this.props.disabled}/>
        </div>
      </div>
    </ColumnLayout>;
  }
}
